<template>
  <div class="vd-gl-content">
    <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="cookie">
        <a-input v-model="form.cookie" type="textarea" rows="8" />
      </a-form-model-item>
      <a-form-model-item label="_bqqcsrf">
        <a-input v-model="form.csrf"></a-input>
      </a-form-model-item>

      <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
        <a-button type="primary" @click="getData" :loading="loading">
          更新数据
        </a-button>
      </a-form-model-item>
    </a-form-model>
    <a-divider />

    <a-row class="vd-toolbar">
      <a-col class="vd-bar vd-left">
        <a-button
          style="margin-right: 8px"
          type="primary"
          @click="exportAreaData"
        >
          导出按照地市
        </a-button>

        <a-button
          type="primary"
          @click="exportData"
          :disabled="list.length === 0"
        >
          导出数据
        </a-button>
      </a-col>
    </a-row>
    <a-table row-key="code" :data-source="list" :pagination="pagination">
      <a-table-column title="群名称" data-index="name" />
      <a-table-column title="群号码/二维码" data-index="code" />
      <a-table-column title="群类型" data-index="type" />
      <a-table-column title="群主" data-index="leader" />
      <a-table-column title="群主工号" data-index="leader_account" />
      <a-table-column title="群人数" data-index="volume" />
      <a-table-column title="创建时间" data-index="createTime" />
    </a-table>
  </div>
</template>

<script>
import { qq_group_area_excel, qq_group_excel } from '@/api/tool'
import XLSX from 'xlsx'

export default {
  name: 'standard_excel',
  data() {
    return {
      loading: false,
      areaList: [],
      list: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        onChange: (page) => {
          this.pagination.current = page
        },
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        csrf: undefined,
        cookie: undefined,
      },
    }
  },
  methods: {
    getData() {
      this.loading = true
      qq_group_excel({
        cookie: this.form.cookie,
        csrf: this.form.csrf,
      }).then((res) => {
        this.loading = false
        if (res.code === 1) {
          console.log(res)
          this.pagination.total = res.total
          this.list = res.list
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    exportAreaData() {
      qq_group_area_excel().then((res) => {
        if (res.code === 1) {
          const ws = XLSX.utils.json_to_sheet(res.list)
          let workbook = XLSX.utils.book_new()

          XLSX.utils.book_append_sheet(workbook, ws, 'SheetJS')

          XLSX.writeFile(workbook, 'qq_group_area_data.xlsx', {
            type: 'base64',
            bookType: 'xlsx',
          })
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    exportData() {
      const ws = XLSX.utils.json_to_sheet(this.list)
      console.log(ws)
      let workbook = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(workbook, ws, 'SheetJS')

      XLSX.writeFile(workbook, 'qq_group_data.xlsx', {
        type: 'base64',
        bookType: 'xlsx',
      })
    },
  },
}
</script>

<style scoped></style>
